<template>
  <div class="nuttrema-jumbotron">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-jumbotron',
};
</script>

<style lang="scss" scoped>
  .nuttrema-jumbotron {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-direction: column;
    justify-content: center;

    padding: 2em 1em;

    > * {
      display: flex;
    }

    section {
      display: flex;
      flex: 0 1 80%;
      margin: 2em 0 0;
      flex-direction: column;
      p {
        font-size: 1.1em;
        line-height: 1.35;
        margin-bottom: 0.5em;
      }
    }

    h1, h2, h3, h4, h5, p {
      font-family: 'Asap';
    }

    h1 {
      font-size: 3em;
      font-weight: 700;
      line-height: 1.15;
      text-align: center;
    }

    h4 {
      font-size: 1.5em;
      font-weight: 400;
      text-align: center;
      margin-top: 0.5em;
    }

    &.theme-turquoise, .nuttrema-theme-professional-turquoise & {
      > * {
        color: #fff;
      }
    }

    &.theme-topography, .nuttrema-theme-professional-topography & {
      > * {
        color: #475669;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/panels/nuttrema-jumbotron.vue